export default __webpack_public_path__ + "static/dc-gallery-view-958089f9a471d96aff7fcb0f91dde45f.png";